import React from 'react';
import { Tooltip, Chip } from '@weezevent/nacre';

import Styles from '../../../styles/rate/rateMembershipInfo.module.css';

import { useTranslation } from 'react-i18next';

export function RateMembershipInfo({ rate, detail = false }) {
    const { t } = useTranslation();
    if (!rate?.is_membership_rate) {
        return null;
    }
    const position = detail ? 'bottom' : 'top';
    const styleOption = detail ? Styles['rate-membership-chip-detail'] : Styles['rate-membership-chip'];

    return (
        <Tooltip triggerOnHover={true} title={t('ticket.rates.rateMembershipTooltip')} position={position}>
            <Chip icon={'id-card-alt'} className={`${Styles['rate-membership-chip']} ${styleOption}`} />
        </Tooltip>
    );
}
